import { render, staticRenderFns } from "./ModalLeadsStatusUpdate.vue?vue&type=template&id=3dba53ba&"
import script from "./ModalLeadsStatusUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalLeadsStatusUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports